export let ChatState;

(function (ChatState) {
  ChatState["RESUME"] = "resume";
  ChatState["INITIALISED"] = "init";
  ChatState["UNINITIALISED"] = "uninitialised";
  ChatState["PRE_CHAT"] = "preChat";
  ChatState["POST_CHAT"] = "postChat";
  ChatState["OFFLINE"] = "offline";
  ChatState["WAITNIG"] = "waiting";
  ChatState["CHATTING"] = "chatting";
  ChatState["ENDED"] = "ended";
  ChatState["INTERACTIVE"] = "interective";
  ChatState["NOT_FOUND"] = "Notfound";
})(ChatState || (ChatState = {}));

export let AgentsState;

(function (AgentsState) {
  AgentsState[AgentsState["ONLINE"] = 1] = "ONLINE";
  AgentsState[AgentsState["OFFLINE"] = 2] = "OFFLINE";
  AgentsState[AgentsState["BUSY"] = 4] = "BUSY";
})(AgentsState || (AgentsState = {}));

export let EngagementTypes;

(function (EngagementTypes) {
  EngagementTypes[EngagementTypes["PEELING_CORNER"] = 0] = "PEELING_CORNER";
  EngagementTypes[EngagementTypes["OVERLAY"] = 1] = "OVERLAY";
  EngagementTypes[EngagementTypes["TOASTER"] = 2] = "TOASTER";
  EngagementTypes[EngagementTypes["SLIDE_OUT"] = 3] = "SLIDE_OUT";
  EngagementTypes[EngagementTypes["EMBEDDED"] = 5] = "EMBEDDED";
  EngagementTypes[EngagementTypes["STICKY"] = 6] = "STICKY";
})(EngagementTypes || (EngagementTypes = {}));

export let ConversationState;

(function (ConversationState) {
  ConversationState["RESUME"] = "resume";
  ConversationState["INITIALISED"] = "initialised";
  ConversationState["UNINITIALISED"] = "uninitialised";
  ConversationState["WAITNIG"] = "waitning";
  ConversationState["CHATTING"] = "chatting";
  ConversationState["ENDED"] = "ended";
})(ConversationState || (ConversationState = {}));

export let State;

(function (State) {
  State["NOT_INITIALISED"] = "NOT_INITIALISED";
  State["INITIALISING"] = "INITIALISING";
  State["READY"] = "READY";
  State["FAILED"] = "FAILED";
})(State || (State = {}));

export let WindowState;

(function (WindowState) {
  WindowState["OPEN"] = "OPEN";
  WindowState["CLOSED"] = "CLOSED";
  WindowState["MINIMISED"] = "MINIMISED";
  WindowState["UNKOWN"] = "UNKOWN";
})(WindowState || (WindowState = {}));

export let OfferState;

(function (OfferState) {
  OfferState["STARTED"] = "STARTED";
  OfferState["READY"] = "READY";
  OfferState["DISPLAYED"] = "DISPLAYED";
  OfferState["EXPIRED"] = "EXPIRED";
  OfferState["DECLINED"] = "DECLINED";
  OfferState["REMOVED"] = "REMOVED";
})(OfferState || (OfferState = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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